export default "__VITE_ASSET__cda6a418__"